import {setLocale as setVeeLocale} from "@vee-validate/i18n"

export const useLanguage = () => {
    const {setLocale: setI18nLocale, locale} = useI18n({useScope: 'global'})

    const lang = useLocalStorage<'de' | 'en'>('lang', locale.value)
    const isChangingLang = ref(false)

    const toggle = computed({
        get: () => lang.value === 'en',
        set: async (value) => {
            lang.value = value ? 'en' : 'de'
            await changeLang(lang.value)
        }
    })

    const setLocale = async (locale: 'en' | 'de') => {
        lang.value = locale
        await changeLang(locale)
    }

    const changeLang = async (lang: 'en' | 'de') => {
        isChangingLang.value = true
        await setI18nLocale(lang)
        setVeeLocale(lang)
        useNuxtApp().$switchZxcvbnLocale(lang)
        await $lara.put(useNuxtApp().$apiRoute('spa.settings.locale'), {body: {locale: lang}})
        isChangingLang.value = false
    }

    return {
        toggle,
        lang,
        isChangingLang,
        setLocale,
    }
}